import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52d68d45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "confirm-lead-creation" }
const _hoisted_2 = { class: "q-px-lg q-mb-lg" }
const _hoisted_3 = { class: "ellipsis flex items-center" }
const _hoisted_4 = {
  key: 0,
  class: "q-mr-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_iap_chip = _resolveComponent("iap-chip")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_toolbar, _normalizeProps(_guardReactiveProps(_ctx.TEXT_QUATERNARY_TITLE)), {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t(`LEAD_CREATION_STEPS.STEP-${_ctx.step}`)), 1)
      ]),
      _: 1
    }, 16),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _mergeProps(_ctx.TEXT_SMALL_BODY, { class: "q-mb-sm q-mt-md" }), _toDisplayString(_ctx.t('BRIEF.CAP.SING')), 17),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_avatar, {
          color: _ctx.getColorName(_ctx.selectedBrief.style),
          class: "text-uppercase q-mr-xs",
          rounded: "",
          size: "20px",
          "text-color": "white"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.selectedBrief.name.charAt(0)), 1)
          ]),
          _: 1
        }, 8, ["color"]),
        (_ctx.selectedBrief.group)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createVNode(_component_iap_chip, {
                "tooltip-label": _ctx.selectedBrief.group.label,
                label: _ctx.selectedBrief.group.label
              }, null, 8, ["tooltip-label", "label"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), _toDisplayString(_ctx.selectedBrief.name), 17),
        _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.selectedBrief.name), 1)
          ]),
          _: 1
        }, 16)
      ]),
      _createElementVNode("div", _mergeProps(_ctx.TEXT_SMALL_BODY, { class: "q-mb-sm q-mt-md" }), _toDisplayString(_ctx.t('TYPE')), 17),
      _createElementVNode("div", _mergeProps(_ctx.TEXT_CONTENT_BODY, { class: "ellipsis" }), [
        _createVNode(_component_q_icon, _mergeProps({
          name: _ctx.assetCategoryIcon,
          class: "q-mr-xs"
        }, _ctx.ICON_PROPS.BTN_LG), null, 16, ["name"]),
        _createTextVNode(" " + _toDisplayString(_ctx.t(`ASSET_TYPES.${_ctx.selectedCategory}`)), 1)
      ], 16),
      _createElementVNode("div", _mergeProps(_ctx.TEXT_SMALL_BODY, { class: "q-mb-sm q-mt-md" }), _toDisplayString(_ctx.t('COMPANY_LABEL')), 17),
      _createElementVNode("div", _mergeProps(_ctx.TEXT_CONTENT_BODY, { class: "ellipsis" }), [
        _createVNode(_component_q_icon, _mergeProps({
          name: _ctx.ICONS_NAME.COMPANY_OUTLINE,
          class: "q-mr-xs"
        }, _ctx.ICON_PROPS.BTN_LG), null, 16, ["name"]),
        _createTextVNode(" " + _toDisplayString(_ctx.selectedCompany.name) + " ", 1),
        _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.selectedCompany.name), 1)
          ]),
          _: 1
        }, 16)
      ], 16),
      (_ctx.showDealType)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _mergeProps(_ctx.TEXT_SMALL_BODY, { class: "q-mb-sm q-mt-md" }), _toDisplayString(_ctx.t('DEAL_TYPE', { Lead: _ctx.t('LEAD.CAP.SING') })), 17),
            _createElementVNode("div", _mergeProps(_ctx.TEXT_CONTENT_BODY, { class: "ellipsis" }), [
              _createTextVNode(_toDisplayString(_ctx.dealTypeName) + " ", 1),
              _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.dealTypeName), 1)
                ]),
                _: 1
              }, 16)
            ], 16)
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _mergeProps(_ctx.TEXT_SMALL_BODY, { class: "q-mb-sm q-mt-md" }), _toDisplayString(_ctx.t('LEAD.CAP.SING')), 17),
      _createElementVNode("div", _mergeProps(_ctx.TEXT_CONTENT_BODY, { class: "ellipsis" }), [
        _createVNode(_component_q_icon, _mergeProps({
          name: _ctx.ICONS_NAME.FILE_OUTLINE,
          class: "q-mr-xs"
        }, _ctx.ICON_PROPS.BTN_LG), null, 16, ["name"]),
        _createTextVNode(" " + _toDisplayString(_ctx.assetName) + " ", 1),
        _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.assetName), 1)
          ]),
          _: 1
        }, 16)
      ], 16),
      (_ctx.contact)
        ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 1 }, _ctx.TEXT_SMALL_BODY, { class: "q-mb-sm q-mt-md" }), _toDisplayString(_ctx.t('CONTACT.CAP.SING')), 17))
        : _createCommentVNode("", true),
      (_ctx.contact)
        ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 2 }, _ctx.TEXT_CONTENT_BODY, { class: "ellipsis" }), [
            _createTextVNode(_toDisplayString(_ctx.contact.dobjPrettifiedBusinessWiseId) + " ", 1),
            _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.contact.dobjPrettifiedBusinessWiseId), 1)
              ]),
              _: 1
            }, 16)
          ], 16))
        : _createCommentVNode("", true),
      (_ctx.meeting)
        ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 3 }, _ctx.TEXT_SMALL_BODY, { class: "q-mb-sm q-mt-md" }), _toDisplayString(_ctx.t('MEETING.CAP.SING')), 17))
        : _createCommentVNode("", true),
      (_ctx.meeting)
        ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 4 }, _ctx.TEXT_CONTENT_BODY, { class: "ellipsis" }), [
            _createTextVNode(_toDisplayString(_ctx.meeting.title) + " ", 1),
            _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.meeting.title), 1)
              ]),
              _: 1
            }, 16)
          ], 16))
        : _createCommentVNode("", true),
      (_ctx.origin)
        ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 5 }, _ctx.TEXT_SMALL_BODY, { class: "q-mb-sm q-mt-md" }), _toDisplayString(_ctx.t('ORIGIN')), 17))
        : _createCommentVNode("", true),
      (_ctx.origin)
        ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 6 }, _ctx.TEXT_CONTENT_BODY, { class: "ellipsis" }), [
            _createTextVNode(_toDisplayString(_ctx.origin.label) + " ", 1),
            _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.origin.label), 1)
              ]),
              _: 1
            }, 16)
          ], 16))
        : _createCommentVNode("", true),
      (_ctx.originEntity)
        ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 7 }, _ctx.TEXT_SMALL_BODY, { class: "q-mb-sm q-mt-md" }), _toDisplayString(_ctx.t('ORIGIN_ENTITY')), 17))
        : _createCommentVNode("", true),
      (_ctx.originEntity)
        ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 8 }, _ctx.TEXT_CONTENT_BODY, { class: "ellipsis" }), [
            _createTextVNode(_toDisplayString(_ctx.originEntity.name) + " ", 1),
            _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.originEntity.name), 1)
              ]),
              _: 1
            }, 16)
          ], 16))
        : _createCommentVNode("", true)
    ])
  ]))
}